import FilePicker from './FilePicker.vue'

export default FilePicker
